import { createContext, useCallback, useContext, useEffect, useRef } from "react";
import { broadcast, useChannel } from "./useChannel";
import { newID } from "../utils/unique";


export interface SaveState {
	channel: string,
}

export const SaveAwarenessMessages = {
	REQUEST_SAVE: "request-save",
}

export const SaveContext = createContext({} as SaveState);

export function requestSave(channel: string) {
	const msg = {
		type: SaveAwarenessMessages.REQUEST_SAVE,
		result: true,
	};
	broadcast(channel, msg);
	if (msg.result) {
		// good to save
		return true;
	} else {
		return false;
	}
}

export function useSaveContext() {
	const result = useRef({} as SaveState);
	if (!result.current.channel) result.current.channel = newID();
	return result.current;
}

export function useSaveAwareness(onSaveRequested: () => boolean) {
	const context = useContext(SaveContext);

	useChannel(context.channel, useCallback((msg: any) => {
		
		if (msg.type === SaveAwarenessMessages.REQUEST_SAVE) {
			const ok = onSaveRequested();
			if (!ok) {
				msg.result = false;
				msg.cancelled = true;
			}	
		}

	}, [context.channel, onSaveRequested]));


}